// @mui
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// utils

// ----------------------------------------------------------------------

const RenderEditButton = ({ permission, link, iconSize }) => {
    const permissionArry = useSelector((state) => state.Login.permissionArry);

    const authorize = permissionArry.includes(permission)
    return (
        <>
            {authorize &&
                <Link to={link} className="edit-icon"><i className={`ri-pencil-line ${iconSize && iconSize}`}></i></Link>
            }

        </>

    );
}
export default (RenderEditButton);
